package com.vizio.redwolf.utils.clientprovider

import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig

object BasicClientProvider : ConfigurableClientProvider() {

    override val lazyClientInitDelegate: Lazy<HttpClient> = lazy {
        val clientConfig: HttpClientConfig<*>.() -> Unit = {
            installCoreClientConfig()
        }
        HttpClient(clientConfig)
    }

    override val httpClient: HttpClient by lazyClientInitDelegate

    override fun close() {
        httpClient.close()
    }

}
